/**
 * 系统管理
 */
import {getOperationTree} from "@/api/system/operation";
import {findPermission} from "@/api/system/peimission";
import {findRole} from "@/api/system/role";
import { defineStore } from "pinia";
const useSystemStore = defineStore("system", {
  state: () => ({
    // 所有操作
    allOperations: [],
    // 所有许可
    allPermissions: [],
    // 获取所有角色
    allRoles: []
  }),
  actions: {
    getAllOperations( forceRefresh) {
      let _this = this
      if (_this.allOperations.length === 0 || forceRefresh) {
        return  getOperationTree().then(resData => {
          _this.allOperations = resData.data
          return  _this.allOperations
        })
      }else{
        return  _this.allOperations
      }
    },
    // 获取被选中的操作
    async getCheckedOperations(checkedOperations) {
      let _this =this
      let arr = await _this.getAllOperations()
      return operationIteration(arr, checkedOperations)
    },


    // 获取所有许可
    getAllPermission(forceRefresh) {
      let _this = this
      if (_this.allPermissions.length === 0 || forceRefresh) {
        return findPermission().then(resData => {
          _this.allPermissions = resData.data
          return _this.allPermissions
        })
      }else{
        return _this.allPermissions
      }
    },

    // 获取所有角色
    getAllRoles(forceRefresh) {
      let _this = this
      if (_this.allRoles.length === 0 || forceRefresh) {
       return  findRole().then(resData => {
          _this.allRoles = resData.data
          return _this.allRoles
        })
      }else{
        return _this.allRoles
      }
    }
  }
});

export default useSystemStore;
/**
 * 迭代操作 子操作列表
 * @param allOps 所有操作
 * @param checkOps 选中的操作
 * @returns {*[]}
 */
const operationIteration = (allOps, checkOps) => {
  const ops = []
  allOps.forEach(op => {
    if (op.children && op.children.length > 0) {
      ops.push(...operationIteration(op.children, checkOps))
    } else {
      if (checkOps.indexOf(op.operationId) !== -1) {
        ops.push(op.operationId)
      }
    }
  })
  return ops

}
